import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page93() {
  useEffect(() => {
    document.title = "Маяк — Страница 92"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page91" />
        <ForwardLink href="/page93" />
      </div>

      <p style={{ textAlign: "right" }}>92.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Гав! Гав!!
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Вот хороший мальчик.<br/>
        Хороший пес.
      </p>
      <p>Длинная пауза.</p>
      <p style={{ textAlign: "center" }}>А теперь перевернись.</p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ. РЯДОМ С ЯМОЙ – ПОЛДЕНЬ</p>
      <p>
        Шторм действительно закончился. С помещений сорваны<br/>
        обшивка и черепица. Сарая с припасами нигде<br/>
        не видно.
      </p>
      <p>
        МОЛОДОЙ выгуливает СТАРИКА на поводке, ну, веревке на шее. СТАРИК<br/>
        ползет на четвереньках.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Хороший мальчик.
      </p>
      <p>МОЛОДОЙ ведет СТАРИКА к ЯМЕ РАЗМЕРОМ С МОГИЛУ, которую они вырыли.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        Полезай туда, старый пес. Там<br/>
        твое место.
      </p>
      <p>Пауза.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        Делай как я говорю, пес!
      </p>
      <p>
        Он погружается в сырую, илистую могилу. Садится, полу-<br/>
        погруженный в воду и грязь примерно на фут.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        Вот и молодец.
      </p>
      <p>МОЛОДОЙ берет лопату...</p>
      <p>Он начинает закапывать СТАРИКА.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Нет!
      </p>
      <p>МОЛОДОЙ еще больше засыпает его землей и илом...</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Хочешь посмотреть, что в этом<br/>
        фонаре?<br/>
        (ДАЛЕЕ)
      </p>
      <p style={{ textAlign: "right" }}>92.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page91" />
        <ForwardLink href="/page93" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710718482/the-lighthouse-script/hqurk0mipmjoeuypgnz2.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page93;
